// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d3c75d57","170":"4a0d026d","297":"5791c38c","453":"2f18efda","845":"2028510e"}[chunkId] + ".chunk.js";
};